export default __webpack_public_path__ + "static/media/Graphics_letterpad-02-min.7aa4c6ac.jpg";